import { getDateRangeISOString } from "hybridspace-common/lib/utils/getDateRangeISOString";
import { createObservableOperation } from "owa-observable-operation";

import fetchAllPeopleInsights from "./fetchAllPeopleInsights";

import type { DateRange } from "owa-datetime-utils";
import type { UserEmailAddress } from "accelerator-aad/lib/UserEmailAddress";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";

const dest = createObservableOperation("PLACES_LOAD_ALL_PEOPLE_INSIGHTS", (dateRange: DateRange, collaborators: UserEmailAddress[]): {
    dateRange: DateRange;
    collaborators: UserEmailAddress[];
} => ({
    dateRange,
    collaborators,
}), ({ dateRange }) => getDateRangeISOString(dateRange), ({ dateRange, collaborators }) => fetchAllPeopleInsights(dateRange, collaborators), () => getModuleContextMailboxInfo());
const loadAllPeopleInsightsSucceeded: (actionMessage: {
    dateRange: DateRange;
    collaborators: UserEmailAddress[];
} & {
    result: Map<UserEmailAddress, string[]>;
}) => {
    dateRange: DateRange;
    collaborators: UserEmailAddress[];
} & {
    result: Map<UserEmailAddress, string[]>;
} = dest.onSucceeded;
const loadAllPeopleInsights: (dateRange: DateRange, collaborators: UserEmailAddress[]) => {
    dateRange: DateRange;
    collaborators: UserEmailAddress[];
} = dest.start;

export { loadAllPeopleInsightsSucceeded, loadAllPeopleInsights };
